<!--错误代码-->
<template>
  <div class="error-page">
    <div class="error-page-title">
      <i class="iconfont iconapiwendang_cuowudaima"></i>
      <span>{{ $lang('错误代码') }}</span>
    </div>
    <el-table :data="dataList" border height="calc(100% - 70px)" style="width: 100%;border-radius: 4px;margin-top: 20px;">
      <el-table-column prop="code" :label="$lang('错误代码')" width="200px" show-overflow-tooltip></el-table-column>
      <el-table-column prop="desc" :label="$lang('错误描述')" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span>{{ $lang(row.desc) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [
        { code: '1', desc: 'sucess' },
        { code: '145003052', desc: 'digest is empty!' },
        { code: '145003051', desc: 'apiAccount is empty!' },
        { code: '145003053', desc: 'timestamp is empty!' },
        { code: '145003010', desc: 'API account does not exist' },
        { code: '145003050', desc: 'Illegal parameters' },
        { code: '145003030', desc: 'headers signature verification failed' },
        { code: '145003012', desc: 'API account has no interface permissions' },
        { code: '999011010', desc: 'customer not exist' },
        { code: '999011020', desc: 'customer is disable' },
        { code: '999011030', desc: 'customer is locked' },
        { code: '999001030', desc: 'customerCode or password is wrong' },
        { code: '145005004', desc: 'This delivery address is temporarily suspended due to objective reasons' },
        { code: '999009010', desc: 'No corresponding origin information was found' },
        { code: '999009020', desc: 'No corresponding destination information was found' },
        { code: '1450033315', desc: 'Please fill in the correct sending/receiving district' },
        { code: '145003204', desc: 'Duplicate order please update customer order number' },
        { code: '145005005', desc: 'billcode acquisition failed' },
        { code: '145003100', desc: 'Illegal waybill number' },
        { code: '145003502', desc: 'The quantity of the waybill number exceeds 30' },
        { code: '999010010', desc: 'order status can not be cancel' },
        { code: '999002000', desc: 'Data not found' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.error-page {
  box-sizing: border-box;
  padding: 30px;
  background: #ffffff;
  height: calc(100vh - 104px);
  &-title {
    display: flex;
    align-items: center;
    height: 50px;
    font-weight: 600;
    i {
      font-size: 24px;
      color: #c31422;
      margin-right: 15px;
    }
    span {
      color: #2b2d42;
      font-size: 22px;
    }
  }
}
</style>
